import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'courses-list',
  templateUrl: './courses-list.component.html',
  styleUrls: ['./courses-list.component.scss']
})
export class CoursesListComponent implements OnInit {

  courses = [
    {
      name: 'Bateria e Leitura para Bateristas',
      start: 'Saiba mais',
      // description: 'Aprenda com o Prof. <u>Bruno Gafanhoto</u>, Mestre em Música pela Jamey Aebersold Jazz Program (EUA), as técnicas que ele aprendeu em mais de 10 anos de experiência como baterista e professor. De Rock e Funk até Jazz e Música Brasileira, tenha um curso montado só para você, de acordo com seus interesses e habilidades.',
      description: 'Aprenda com o Prof. <u>Bruno Gafanhoto</u>, Mestre em Música pelo Jamey Aebersold (EUA), o que ele adquiriu em 15 anos de experiência como baterista. São mais de 120 aulas em Jazz, Ritmos Brasileiros, Rock, Funk e Leitura!',
      image: 'battery1.png',
      link:'https://lumieducacao.com/cursos/bateria'
    },
    {
      name: 'Baixo',
      // description: 'Aprenda com o Prof. <u>Bruno Migliari</u>, baixista do Frejat desde 2001 e Simone desde 2013, linhas de Baixo e exercícios técnicos voltados para Rock, Funk, Jazz e Ritmos Brasileiros em um curso automaticamente personalizado para você de acordo com seus interesses e habilidades.',
      description:'Aprenda com o Prof. <u>Bruno Migliari</u>, baixista que tocou em palcos pelo mundo com Frejat desde 2001 e Simone desde 2013. São mais de 90 aulas sobre linhas de Baixo e exercícios técnicos voltados para Rock, Funk, Jazz e Ritmos Brasileiros!',
      start: 'Saiba mais',
      image: 'bass1.png',
      link:'https://lumieducacao.com/cursos/baixo'

    },
    {
      name: 'Teclado',
      description:'Aprenda com o Prof. <u>Gregoree Junior</u> o que o levou a acompanhar artistas como Só Pra Contrariar, Diego Gonzáles (RBD) e outros. São mais de 70 aulas sobre Acordes, Escalas e Acompanhamentos em Pop, Rock e Ritmos Brasileiros!',
      // description: 'Aprenda com o Prof. <u>Gregoree Junior</u>, tecladista com mais de 15 anos de experiência acompanhando artistas como Só Pra Contrariar, Diego Gonzáles (Rebeldes), Toni Garrido, Rappin Wood e outros. Trazendo a musicalidade e versatilidade como suas principais marcas, Gregoree é também produtor musical de grande renome no meio musical cristão.',
      start: 'Saiba mais',
      image: 'teclado.png',
      link:'https://lumieducacao.com/cursos/teclado'

    },
    {
      name: 'Guitarra',
      description:'Aprenda com o Prof. <u>Billy Brandão</u>, um dos maiores guitarristas do Brasil, com mais de 30 anos de carreira tocando com Frejat, Erasmo Carlos, Moska, Ana Carolina e outros. São mais de 60 aulas sobre Rock, Blues, Música Brasileira e mais!',
      start: 'Saiba mais',
      image: 'guitarra.jpg',
      link:'https://lumieducacao.com/cursos/guitarra'

    },
    {
      name: 'Voz e Violão',
      description:'Aprenda com a Prof.<u>Larissa Vitorino</u>, semifinalista do The Voice Brasil 2020 e Graduada em Música - Violão (UFU), com mais de 500 mil streams. São mais de 50 aulas com técnicas de Canto, Violão e como fazer um Voz e Violão de alto nível!',
      start: 'Saiba mais',
      image: 'voz_e_violao.jpg',
      link:'https://lumieducacao.com/cursos/voz-e-violao'

    },

    {
      name: 'Moderno Pandeiro',
      description:'Aprenda com o Prof. <u>Edu Szajnbrum</u>, Mestre em Música (UNIRIO), que já comandou a percussão de artistas como Marisa Monte, Gilberto Gil, Lenine e outros. São mais de 50 aulas sobre o Pandeiro Ritmos Brasileiros e nos Ritmos do Mundo!',
      // description: 'Aprenda com o Prof. <u>Gregoree Junior</u>, tecladista com mais de 15 anos de experiência acompanhando artistas como Só Pra Contrariar, Diego Gonzáles (Rebeldes), Toni Garrido, Rappin Wood e outros. Trazendo a musicalidade e versatilidade como suas principais marcas, Gregoree é também produtor musical de grande renome no meio musical cristão.',
      start: 'Saiba mais',
      image: 'moderno_pandeiro.jpg',
      link:'https://lumieducacao.com/cursos/moderno-pandeiro'

    },
    {
      name: 'Teoria Musical e Leitura de Partitura',
      description:'Aprenda com os Profs. <u>Bruno Gafanhoto e Bruno Migliari</u>, tudo o que você precisa saber para ler partitura, dominar a teoria e ter mais oportunidades na música. São mais de 50 aulas sobre Rítmica, Harmonia, Escalas, Cifras e mais!',
      start: 'Saiba mais',
      image: 'teoria_musical.jpg',
      link:'https://lumieducacao.com/cursos/teoria-musical'

    },

    {
      name: 'Foto e Vídeo com Celular',
      description:'Aprenda com o Prof. <u>Jorge Brivilati</u>, fotógrafo e diretor de cinema premiado com o Cannes Lions Award, como fazer fotos e vídeos profissionais usando apenas o seu celular. São mais de 20 aulas sobre iluminação, enquadramento e mais!',
      // description: 'Aprenda com o Prof. <u>Gregoree Junior</u>, tecladista com mais de 15 anos de experiência acompanhando artistas como Só Pra Contrariar, Diego Gonzáles (Rebeldes), Toni Garrido, Rappin Wood e outros. Trazendo a musicalidade e versatilidade como suas principais marcas, Gregoree é também produtor musical de grande renome no meio musical cristão.',
      start: 'Saiba mais',
      image: 'foto_video.jpg',
      link:'https://lumieducacao.com/cursos/foto-e-video-com-celular'

    },
    {
      name: 'Desenho',
      description:'Aprenda com o Prof. <u>Tiago Palma</u>, Ilustrador, Diretor de arte e Quadrinista Graduado pelo UniCeub. Com 12 anos de experiência, já desenhou para o UFC, Revista Traços e outros. São mais de 20 aulas com técnicas para melhorar seu traço!',
      start: 'Saiba mais',
      image: 'desenho.jpg',
      link:'https://lumieducacao.com/cursos/desenho'

    },
    {
      name: 'Como Criar Um Negócio Criativo?',
      description:'Aprenda com os Profs. <u>Luiz Gomes e Jeff Simão</u>, heads da aceleradora Overdrives, como botar em prática o seu Negócio desde a base até a expansão. São mais de 30 aulas com a expertise de quem já investiu em 25 negócios desde 2019!',
      // description: 'Aprenda com o Prof. <u>Gregoree Junior</u>, tecladista com mais de 15 anos de experiência acompanhando artistas como Só Pra Contrariar, Diego Gonzáles (Rebeldes), Toni Garrido, Rappin Wood e outros. Trazendo a musicalidade e versatilidade como suas principais marcas, Gregoree é também produtor musical de grande renome no meio musical cristão.',
      start: 'Saiba mais',
      image: 'negocio_creativo.jpg',
      link:'https://lumieducacao.com/cursos/como-criar-um-negocio-criativo'

    },
    {
      name: 'Novos Cursos!',
      // description: 'Tenha um curso online de Fotografia montado só para você, de acordo com seus interesses e habilidades.',
      description: 'Em breve novos cursos de Escrita Criativa, Retrato Feminino, Design Gráfico, Marketing Criativo e mais!',
      start: '',
      image: 'novos_cursos_2023.jpg'
    },
    
  ];

  constructor(private router: Router) {
    // console.log('this is profile!', this.plans, this.showTrial, this);


  }
  goTo(link){
    window.location.href=link;
  }

  triggerRoute(route){
    console.log("route!", route)
    if(route == 'Experimente'){
      this.router.navigate(['/register']);
    }
  }
  ngOnInit() {
  }

}
